import moment from "moment";
import React, { createContext, useState } from "react";

import { AUTH_KEY, TOKEN_LIFETIME } from "src/config/constants";
import { OpenAPI } from "src/core/helpers/api";
import { IAuth, IAuthContext } from "src/types/global";

export const AuthContext = createContext<IAuthContext | null>(null);

export const AuthProvider: React.FC<React.ReactNode> = ({ children }) => {
  const [auth, setAuth] = useState<IAuth | null>(() => {
    try {
      const userJsonData = window.localStorage.getItem(AUTH_KEY);
      return userJsonData ? validateUserData(userJsonData) : null;
    } catch (e: any) {
      return null;
    }
  });
  const setAuthData = (userData: IAuth, setTokenExpire: boolean) => {
    if (setTokenExpire) {
      userData.expires = setTokenExpiration();
    }
    setAuth(userData);
    window.localStorage.setItem(AUTH_KEY, JSON.stringify(userData));
    OpenAPI.TOKEN = userData?.jwtToken !== null ? userData.jwtToken : "";
  };
  const updateProfileData = (newUserData: IAuth) => {
    let userJsonData = window.localStorage.getItem(AUTH_KEY);
    if (userJsonData) {
      let userData: IAuth = JSON.parse(userJsonData);
      userData.firstName = newUserData.firstName;
      userData.lastName = newUserData.lastName;
      userData.targetGroup = newUserData.targetGroup;
      userData.phoneNumber = newUserData.phoneNumber;
      setAuthData(userData, false);
    }
  };

  function clearAuthData() {
    localStorage.removeItem(AUTH_KEY);
    OpenAPI.TOKEN = undefined;
    setAuth(null);
  }

  function setTokenExpiration() {
    let dateNow = moment(new Date());
    let expirationDate = moment(dateNow.add(TOKEN_LIFETIME, "minutes")).valueOf();
    return expirationDate;
  }

  function validateUserData(userJsonData: string) {
    const userData = JSON.parse(userJsonData);
    const dateNow = moment(new Date());
    if (dateNow.valueOf() > userData?.expires) {
      clearAuthData();
      return null;
    }
    OpenAPI.TOKEN = userData?.jwtToken !== null ? userData.jwtToken : "";
    return userData;
  }
  return <AuthContext.Provider value={{ auth, setAuthData, clearAuthData, updateProfileData }}>{children}</AuthContext.Provider>;
};
